/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_VacanciesInputs */

const en_footer_action_vacancies = /** @type {(inputs: Footer_Action_VacanciesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacancies`)
};

/**
* | output |
* | --- |
* | "Vacancies" |
*
* @param {Footer_Action_VacanciesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_vacancies = /** @type {((inputs?: Footer_Action_VacanciesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_VacanciesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_vacancies(inputs)
});